import axiosInstance from '@/axiosInstance';
import type { AxiosResponse } from 'axios';
import type { UserPreferences } from '@/services/UserPreferencesService';

// API wrapper for the current user's persistent UI preferences. The user is resolved
// server-side from the session token, so neither endpoint takes a user id.
export default {
  get(): Promise<AxiosResponse<UserPreferences | null>> {
    return axiosInstance.get(`/api/UserPreference`);
  },
  save(preferences: UserPreferences): Promise<AxiosResponse<void>> {
    return axiosInstance.put(`/api/UserPreference`, preferences);
  },
};
